import { Component, OnDestroy, Input, ViewEncapsulation } from '@angular/core';
import { Ng4LoadingSpinnerService } from './ng4-loading-spinner.service';
import { Subscription } from 'rxjs';
import { DynamicApicallService } from 'src/app/service/dynamic-apicall.service';

/**
 * @description
 * @author Amit Mahida
 * @export
 */
@Component({
  selector: 'app-ng4-loading-spinner',
  templateUrl: './ng4-loading-spinner.component.html',
  styleUrls: ['./ng4-loading-spinner.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class Ng4LoadingSpinnerComponent implements OnDestroy {

  /**
   * @description Default loading spinner template
   * @memberof Ng4LoadingSpinnerComponent
   */
  private privateTemplate =
    `<div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>`;

  /**
   * @description Loading text
   * @memberof Ng4LoadingSpinnerComponent
   */
  private privateLoadingText = '';


  /**
   * @description Defines threhold for not to diplay if time is less than 500ms
   * @memberof Ng4LoadingSpinnerComponent
   */
  private privateThreshold = 500;

  /**
   * @description Defines timeout to hide after time 5000ms
   * @memberof Ng4LoadingSpinnerComponent
   */
  private privateTimeout = 0;

  /**
   * @description Defines z-index property of the loading text
   * @memberof Ng4LoadingSpinnerComponent
   */
  private privateZIndex = 9999;

  /**
   * @description Sets z-index for input text
   * @memberof Ng4LoadingSpinnerComponent
   */
  @Input() public set zIndex(value: number) {
    this.privateZIndex = value;
  }

  /**
   * @description returns z-index for input text
   * @readonly
   * @memberof Ng4LoadingSpinnerComponent
   */
  public get zIndex(): number {
    return this.privateZIndex;
  }

  /**
   * @description Accepts custom template
   * @memberof Ng4LoadingSpinnerComponent
   */
  @Input()
  public set template(value: string) {
    this.privateTemplate = value;
  }


  /**
   * @description Gives the current template
   * @readonly
   * @memberof Ng4LoadingSpinnerComponent
   */
  public get template(): string {
    return this.privateTemplate;
  }


  /**
   * @description Accepts loading text string
   * @memberof Ng4LoadingSpinnerComponent
   */
  @Input()
  public set loadingText(value: string) {
    this.privateLoadingText = value;
  }


  /**
   * @description Gives loading text
   * @readonly
   * @memberof Ng4LoadingSpinnerComponent
   */
  public get loadingText(): string {
    return this.privateLoadingText;
  }


  /**
   * @description Accepts external threshold
   * @memberof Ng4LoadingSpinnerComponent
   */
  @Input()
  public set threshold(value: number) {
    this.privateThreshold = value;
  }


  /**
   * @description
   * @readonly
   * @memberof Ng4LoadingSpinnerComponent
   */
  public get threshold(): number {
    return this.privateThreshold;
  }

  /**
   * @description Accepts external timeout
   * @memberof Ng4LoadingSpinnerComponent
   */
  @Input()
  public set timeout(value: number) {
    this.privateTimeout = value;
  }


  /**
   * @description
   * @readonly
   * @memberof Ng4LoadingSpinnerComponent
   */
  public get timeout(): number {
    return this.privateTimeout;
  }

  /**
   * Subscription
   * @memberof Ng4LoadingSpinnerComponent
   */
  subscription: Subscription;

  /**
   * @description Show/hide spinner
   * @memberof Ng4LoadingSpinnerComponent
   */
  showSpinner = false;

  /**
   * Constructor
   * @param spinnerService Spinner Service
   * @memberof Ng4LoadingSpinnerComponent
   */
  constructor(
    private spinnerService: Ng4LoadingSpinnerService,
    private apiService: DynamicApicallService
  ) {
    this.createServiceSubscription();
    // this.subscription = this.apiService.loaderState$.subscribe((state) => {
    //   this.showSpinner = state;
    // });

  }

  /**
   * Destroy function
   * @memberof Ng4LoadingSpinnerComponent
   */
  ngOnDestroy() {
    // if (this.subscription) {
    this.subscription.unsubscribe();
    // }
  }

  /**
   * Create service subscription
   * @memberof Ng4LoadingSpinnerComponent
   */
  createServiceSubscription() {
    let thresholdTimer: any;
    let timeoutTimer: any;

    this.subscription =
      this.spinnerService.getMessage().subscribe((show) => {
        if (show) {
          if (thresholdTimer) {
            return;
          }
          thresholdTimer = setTimeout(() => {
            thresholdTimer = null;
            this.showSpinner = show;
            if (this.timeout !== 0) {
              timeoutTimer = setTimeout(() => {
                timeoutTimer = null;
                this.showSpinner = false;
              }, this.timeout);
            }
          }, this.threshold);
        } else {
          if (thresholdTimer) {
            clearTimeout(thresholdTimer);
            thresholdTimer = null;
          }
          if (timeoutTimer) {
            clearTimeout(timeoutTimer);
            timeoutTimer = null;
          }
          this.showSpinner = false;
        }
      });
  }
}